// "+ Add" on cart drawer upsell cards: add the variant, then let Denim's drawer re-render itself.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cv-upsell]');
  if (!btn) return;
  e.preventDefault();
  var drawer = document.querySelector('cart-drawer');
  btn.disabled = true;
  var body = new FormData();
  body.append('id', btn.dataset.cvUpsell);
  body.append('quantity', '1');
  body.append('sections', 'cart-drawer,cart-icon-bubble');
  body.append('sections_url', window.location.pathname);
  fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status) { btn.disabled = false; return; }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    })
    .catch(function () { btn.disabled = false; });
});
